import create from 'zustand';
import userApi from 'lib/api/user';
import produce from 'immer';
import useChatStore from 'stores/chat';
import { IChatStore } from 'stores/chat/types';
import { UserGraph } from '../../../../@types/user';

interface IUploadAttachmentPreview {
  file: any;
  previewUrl: any;
  type: 'image' | 'document';
  meta: {
    orientation: 'potrait' | 'landscape' | 'square';
  };
  setFile: (file: any, previewUrl: any, type: 'image' | 'document') => void;
  setFileMeta: (meta: any) => void;
  resetFile: () => void;
}

const uploadAttachmentPreviewStore = create<IUploadAttachmentPreview>((set) => ({
  file: null,
  previewUrl: null,
  type: null,
  meta: null,
  resetFile: () => {
    set({ file: null, previewUrl: null });
  },
  setFile: (file, previewUrl, type) => {
    set({ file, previewUrl, type });
  },
  setFileMeta: (orientation) => {
    set({ meta: { orientation } });
  },
}));

interface IUserProfileStore {
  data: {
    [username: string]: UserGraph;
  };
  fetchUserProfile: (username: string) => Promise<any>;
}

const userProfileStore = create<IUserProfileStore>((set) => ({
  data: {},
  fetchUserProfile: (username) => new Promise((resolve) => {
    useChatStore.setState(
      produce((state: IChatStore) => {
        state.conversation.isLoading = true;
      }),
    );
    userApi.getUserProfileGraph(username)
      .then((res) => {
        const { data } = res.data;
        useChatStore.setState(
          produce((state: IChatStore) => {
            state.conversation.isLoading = false;
          }),
        );
        set(
          produce((state: IUserProfileStore) => {
            state.data[username] = data;
          }),
        );
        resolve(data);
      })
      .catch(() => {
        useChatStore.setState(
          produce((state: IChatStore) => {
            state.conversation.isLoading = false;
          }),
        );
      });
  }),
}));

export {
  uploadAttachmentPreviewStore,
  userProfileStore,
};
